export const formatPhone = (ph: string) => {
  const phone = ph || "";
  // 10 digits: 4155551234
  if (phone.length === 10) {
    return `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`;
  }
  // 11 digits starting with 1: 14155551234
  if (phone.length === 11 && phone.startsWith("1")) {
    return `+1 (${phone.slice(1, 4)}) ${phone.slice(4, 7)}-${phone.slice(7)}`;
  }
  // E.164 format: +14155551234
  if (phone.startsWith("+1") && phone.length === 12) {
    const digits = phone.slice(2);
    return `+1 (${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }

  return phone;
};
